export default "__VITE_ASSET__UK9JS$Ds__"